module.exports = __webpack_public_path__ + "img/link-arrow-rb.a067f266.svg";